import { defineStore } from 'pinia'
import quotesService from '@/services/quotes.service'

export const useQuoteListStore = defineStore('quoteList', {
    state: () => ({
        quoteList: [],
        totalCount: 0,
        currentPage: 1,
        itemsPerPage: 20,
    }),
    actions: {
        setQuoteList(value) {
            this.quoteList = Array.isArray(value) ? value : []
            this.totalCount = this.quoteList.length === 0 ? 0 : this.quoteList.length
        },
        setTotalCount(value) {
            this.totalCount = (value !== null && value !== undefined) ? Number(value) : this.quoteList.length
        },
        setCurrentPage(page) {
            this.currentPage = Number(page) > 0 ? Number(page) : 1
        },
        setItemsPerPage(size) {
            this.itemsPerPage = Number(size) > 0 ? Number(size) : 10
        },
        async fetchQuoteList(filters) {
            const { items, total_count } = await quotesService.searchQuotes(filters)
            this.setQuoteList(items)
            this.setTotalCount(total_count)
            return { items, total_count }
        },
        async assignQuoteToMe(searchActionId) {
            return quotesService.assignQuoteToMe(searchActionId)
        },
        async updateQuoteTypeBySearchActionId(searchActionId, newQuoteType) {
            this.quoteList = this.quoteList.map(item => {
                if (item.id === searchActionId) {
                    console.log(`Updating item with ID ${item.id}`)
                    return { ...item, quote_type: newQuoteType }
                }
                return item
            })
        },
    },
})